<template>
    <div style="width: 100%">
        <el-container>
            <!--左侧导航栏列表-->
            <el-aside width="300px">
                <div class="left_nav_tab">
                    <ul class="left_nav_tab_ul" :class="navId===item.id?'left_nav_tab_ul-active':''"
                        v-for="(item,index) in navList" :key="index">
                        <!--<router-link :to="'/media' + item.id">-->
                        <router-link :to="'/media/'+item.name">
                            <li class="left_nav_tab_ul_li" @click="getNavId(item.id)">
                                <a>{{item.title}}</a>
                            </li>
                        </router-link>
                    </ul>
                </div>
            </el-aside>

            <!--中间部分-->
            <el-main style="padding: 0px">
                <router-view class="mid-main"></router-view>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    export default {
        name: "media",
        data() {
            return {
                navId: 0,
                navList: [
                    {
                        "id":1,
                        "title":"音乐",
                        "name":"music",
                    },
                    {
                        "id":2,
                        "title":"视频",
                        "name":"video",
                    },
                ],
            }
        },
        created(){
            // 获取左侧导航栏
            this.getNavList();
        },
        methods:{
            // 获取左侧导航栏
            getNavList(){
            },
            // 选中颜色
            getNavId(id){
                this.navId = id
            }
        }
    }
</script>

<style scoped>
    /*左侧导航栏*/
    .left_nav_tab_ul{
        list-style: none;
        margin: 0px;
        padding: 0px;
    }
    .left_nav_tab_ul_li{
        /*margin: 12px;*/
        /*margin-left: 10px;*/
    }
    .left_nav_tab_ul_li a{
        font-size: 16px;
        color: #000;
        display: inline-block;
        text-align: center;
        list-style: none;
        margin: 12px 12px 12px 30px;
    }
    .left_nav_tab_ul_li:hover{
        background: #E4E6E9;
        border-radius: 9px;
    }
    .left_nav_tab_ul-active li{
        background: #E4E6E9;
        color: white;
    }
</style>
